module.exports = __webpack_public_path__ + "img/Metro Lipa.66ae32af.png";